import { useState } from "react";

const heroTags = ["BL圈子", "同好讨论", "作品安利", "剧情研读", "同人创作"];

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // 搜索框交互：当前为演示入口，保留关键词即可
    const v = keyword.trim();
    if (v) {
      document.getElementById("topics")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="top"
      className="relative flex min-h-[100vh] w-full items-center overflow-hidden bg-primary-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20warm%20anime%20illustration%20of%20a%20romantic%20cherry%20blossom%20scene%20with%20two%20silhouetted%20figures%20beneath%20blooming%20sakura%20trees%2C%20petals%20drifting%20in%20wind%2C%20dusk%20sky%20in%20rose%20and%20gold%2C%20soft%20dreamy%20lighting%2C%20artistic%20and%20stylized%20not%20photorealistic%2C%20warm%20cozy%20fandom%20atmosphere&width=1800&height=1200&seq=hero-sakura-2026&orientation=landscape"
          alt="腐漫网 - 樱花盛开的同好社区场景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 pb-16 pt-28 text-center md:px-6">
        <div className="animate-fade-up mx-auto inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-100 backdrop-blur-sm">
          <i className="ri-fire-fill text-accent-400"></i>
          同好聚集地 · 随时畅聊 · 一站直达
        </div>

        <h1 className="animate-fade-up mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl" style={{ animationDelay: "0.1s" }}>
          腐漫网
          <span className="mt-2 block font-heading text-2xl font-bold text-accent-300 md:text-4xl">
            腐女同好社区 · BL 圈子互动平台
          </span>
        </h1>

        <p className="animate-fade-up mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-lg" style={{ animationDelay: "0.2s" }}>
          在这里找同好、聊剧情、分享心头好。热门话题、作品讨论、粉丝聚集地一站直达，
          随时参与腐向交流与圈子互动，畅快聊属于我们的话题。
        </p>

        <form
          onSubmit={handleSearch}
          className="animate-fade-up mx-auto mt-8 flex max-w-xl flex-col gap-2 sm:flex-row sm:rounded-full sm:bg-background-50 sm:p-1.5"
          style={{ animationDelay: "0.3s" }}
        >
          <div className="relative flex-1">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索你感兴趣的作品、话题或圈子…"
              className="w-full rounded-full bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 sm:bg-transparent sm:py-3"
              aria-label="搜索"
            />
          </div>
          <button
            type="submit"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始寻找
          </button>
        </form>

        <div className="animate-fade-up mt-6 flex flex-wrap items-center justify-center gap-2" style={{ animationDelay: "0.4s" }}>
          <span className="text-xs text-background-300">热门：</span>
          {heroTags.map((tag) => (
            <a
              key={tag}
              href="#topics"
              className="whitespace-nowrap rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur-sm transition-colors hover:bg-primary-500/80 hover:text-background-50"
            >
              #{tag}
            </a>
          ))}
        </div>

        <div className="animate-fade-up mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4" style={{ animationDelay: "0.5s" }}>
          {[
            { value: "128万", label: "注册同好" },
            { value: "56万", label: "累计话题" },
            { value: "8200", label: "活跃圈子" },
            { value: "24h", label: "全天候陪伴" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-50/15 bg-black/20 px-4 py-4 backdrop-blur-sm"
            >
              <p className="font-heading text-2xl font-black text-accent-300">{s.value}</p>
              <p className="mt-1 text-xs text-background-200">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#topics"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 flex h-11 w-11 animate-float items-center justify-center rounded-full border border-background-50/25 text-background-100"
      >
        <i className="ri-arrow-down-line text-xl"></i>
      </a>
    </section>
  );
}